<template>
  <div>
      <wai-project-search></wai-project-search>
  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
// http://localhost:8080/wai-search-iframe?search_type=2&search_text=mide
import {
  default as WaiProjectSearch
} from '@/wam/components/widgets/WaiProjectSearch';
import { mapGetters } from 'vuex';
export default {
  name: 'wai_search_iframe',
  computed: mapGetters({
    StoreLang: 'StoreLang',
  }),
  components: {
    WaiProjectSearch,
  },
  props: {},
  data () {
    return {};
  },
  created: function () {},
  beforeMount () {},
  mounted: function () {},
  methods: {
  },
  watch: {}
}

</script>

